module.exports = __webpack_public_path__ + "img/whatsapp.eca05782.svg";